export default __webpack_public_path__ + "static/media/srisailamVisitTwo.159f253a.jpg";